module.exports = __webpack_public_path__ + "static_official_spa/img/254game.304be715.png";